$(() => {
  $(document).ready(() => {
    let timeout;
    const classList = `.dumel-main-template, .cms-dumel-footer, .nav__menu,
    .dumel-socialmedia-container-background, .tablet-social-media, .footer, .brand-list`;

    $('.dumel-show-brands').click(() => {
      $(classList).addClass('blur10px');
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        $('.dumel-all-brands').fadeIn(500, 'swing');
        $('body').addClass('no-scroll');
      }, 300);
    });

    $('.dumel-all-brands__close').click(() => {
      $('.dumel-all-brands').fadeOut(500, 'swing', () => {
        $(classList).removeClass('blur10px');
        $('body').removeClass('no-scroll');
      });
    });
  });
});
